import { Bug, ShieldCheck, Heart, Sparkles, Leaf, Trees } from "lucide-react";

const WhyChooseUs = () => {
  const services = [
    {
      icon: Bug,
      title: "Control de Plagas",
    },
    {
      icon: ShieldCheck,
      title: "Inocuidad Alimentaria",
    },
    {
      icon: Heart,
      title: "Salud Pública",
    },
    {
      icon: Sparkles,
      title: "Sanitización",
    },
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-primary relative overflow-hidden">
      {/* Decorative organic elements */}
      <div className="absolute inset-0 opacity-15">
        <div className="absolute top-10 left-10 w-32 md:w-48 h-32 md:h-48 rounded-full bg-white/20 blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-48 md:w-72 h-48 md:h-72 rounded-full bg-white/15 blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 w-28 md:w-40 h-28 md:h-40 rounded-full bg-white/10 blur-2xl"></div>
      </div>

      {/* Leaf pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="leaf-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <path d="M50 10c-3 5-6 10-12 13-6-3-9-8-12-13 3-5 6-10 12-13 6 3 9 8 12 13z" fill="white" fillOpacity="0.3"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#leaf-pattern)"/>
        </svg>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto mb-10 md:mb-14 lg:mb-20">
          <div className="inline-flex items-center gap-2.5 bg-white/20 backdrop-blur-sm rounded-full px-5 py-2.5 md:px-6 md:py-3 mb-6 md:mb-8">
            <Trees className="w-4 h-4 md:w-5 md:h-5 text-white" />
            <span className="text-xs md:text-sm font-semibold text-white">Nuestro Compromiso</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white mb-4 md:mb-6 lg:mb-8 px-2">
            Servimos a la Industria del Control de Plagas
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 leading-relaxed px-4">
            Distribuimos y ponemos al alcance del Controlador Profesional los productos, equipos, suministros e insumos de mayor valor agregado para:
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 max-w-5xl mx-auto">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="bg-white/12 backdrop-blur-sm border border-white/20 rounded-2xl md:rounded-3xl p-6 sm:p-8 lg:p-10 text-center hover:bg-white/20 hover:scale-[1.03] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-14 h-14 md:w-16 lg:w-20 md:h-16 lg:h-20 mx-auto mb-4 md:mb-6 rounded-xl md:rounded-2xl bg-white/20 flex items-center justify-center">
                  <Icon className="w-7 h-7 md:w-8 lg:w-10 md:h-8 lg:h-10 text-white" />
                </div>
                <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-white">
                  {service.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
